import { render, staticRenderFns } from "./CanceledAccount.vue?vue&type=template&id=e52ea8de&scoped=true&"
import script from "./CanceledAccount.vue?vue&type=script&lang=js&"
export * from "./CanceledAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52ea8de",
  null
  
)

export default component.exports